import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'

const StyledForm = styled.form`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const StyledPayPalButton = styled.input`
    background: #fffc63;
    border-radius: 2rem;
    color: #000;
    font-weight: bolder;
    margin: .5rem auto;
    padding: .5rem 1rem;
    text-decoration: none;
    white-space: nowrap;
    border: none;
    font-size: 1rem;
    :hover{
      background: white;
      cursor: pointer;
      color: rgba(0,0,0,.8);
    }
`

export const PayPalButtonTemplate = ({ className, buttonID, children, label }) => {
  return (
    <StyledForm action='https://www.paypal.com/cgi-bin/webscr' method='post' target='_blank'>
      <input type='hidden' name='cmd' value='_s-xclick' />
      <input type='hidden' name='hosted_button_id' value={buttonID} />
      <StyledPayPalButton className={className} type='submit' value={label || children} />
      <img alt='' src='https://www.paypalobjects.com/en_AU/i/scr/pixel.gif' style={{ display: 'none !important' }} width='1' hidden='' height='1' border='0' />
    </StyledForm>
  )
}

export const PayPalButton = ({ className, children, label }) => {
  const query = graphql`
  {
    allMarkdownRemark(
      filter:{
        frontmatter:{
          buttons:{
            donationButtonCode:{
              ne:null
            }
          }
        }
      }
    ){
      edges{
        node{
          frontmatter{
            buttons{
              donationButtonCode
            }
          }
        }
      }
    }
  }
  `

  const render = ({ allMarkdownRemark }) => {
    const { frontmatter } = allMarkdownRemark.edges[0].node
    const { buttons } = frontmatter
    const { donationButtonCode } = buttons
    return <PayPalButtonTemplate className={className} buttonID={donationButtonCode} label={decodeURI(label)}>{ children }</PayPalButtonTemplate>
  }

  return <StaticQuery query={query} render={render} />
}
